export const Header = () => {
  return (
    <header>
      <h1 className="text-center text-success m-3">Employee Directory </h1>

      <div className="m-4 text-center">
        {' '}
        Please click the column name that you would like to search{' '}
      </div>
    </header>
  );
};
